// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/Router'
import store from '@/stores/index'
import axios from '@/axiosConnection'
import toastr from '@/toastr'
import i18n from '@/traductions/config'
// import {
//   defaultLocale
// } from '@/traductions/config'
import Paginate from 'vuejs-paginate'
import RouterLinkGuard from '@/RouterLinkGuard'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Bootstrap Vue Initialization
Vue.use(BootstrapVue)
import {
  Pagination
} from 'bootstrap-vue/es/components'
Vue.use(Pagination)

// Wysiwyg Initialization
Vue.use(wysiwyg, {
  maxHeight: "300px",
  hideModules: {
    "image": true
  },
  forcePlainTextOnPaste: true
});
import wysiwyg from "vue-wysiwyg";

// MomentJS Initialization
const moment = require('moment')
require('moment/locale/fr')
Vue.use(require('vue-moment'), {
  moment
})
// Custom components creation
Vue.component('paginate', Paginate)
Vue.component('router-link-guard', RouterLinkGuard)

import BackLink from "@/components/Global/BackLink";
Vue.component('backlink', BackLink)

import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)

import {
  default as formatDatasMixin
} from '@/mixins/formatDatas';

import {
  default as exportPdfMixin
} from '@/mixins/exportPdf';

// Failure callback for axios interceptor
function errorResponseHandler(error) {
  // Check for errorHandle config
  if (error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false) {
    return Promise.reject(error)
  }

  // Send notification depending on HTTP status, or if a status is given in datas
  if (error.response.data && error.response.data.status) {
    let object_type = router.currentRoute.fullPath.split('/')[1]
    toastr.error(i18n.t('error.' + object_type + '.' + error.response.data.status))
  } else if (error.response.status === 400) {
    toastr.error(i18n.t('http.bad_request'))
  } else if (error.response.status === 401) {
    toastr.error(i18n.t('http.unauthorized'))
  } else if (error.response.status === 403) {
    toastr.error(i18n.t('http.forbidden'))
  } else if (error.response.status === 404) {
    toastr.error(i18n.t('http.not_found'))
  } else if(error.response.status === 500){
    toastr.error(i18n.t(error.response.data.exception))
  }

  // Redirect depending on HTTP status, or push to the congifured path
  if (error.response.config.hasOwnProperty('redirectOnFailure')) {
    router.push(error.response.config.redirectOnFailure)
  } else if (error.response.status === 400) {
    router.back()
  } else if (error.response.status === 401) {
    router.push({
      name: 'Login'
    })
  } else if (error.response.status === 403) {
    router.back()
  } else if (error.response.status === 404) {
    router.push({
      name: 'ErrorNotFound'
    })
  }

  return Promise.reject(error)
}

// Success callback for axios interceptor
function successResponseHandler(response) {
  // Check for successHandle config
  if (response.config.hasOwnProperty('successHandle') && response.config.successHandle === false) {
    return Promise.resolve(response)
  }

  // If request success
  if ([200, 201].includes(response.status)) {
    if (response.data.status) {

      // Send a notification if a status is given in datas
      let object_type = router.currentRoute.fullPath.split('/')[1]

      // Push to the redirect path if congifured
      if (response.config.hasOwnProperty('redirectOnSuccess')) {
        router.push(response.config.redirectOnSuccess)
      }
    }
  }

  return Promise.resolve(response)
}

// before a request is made start the nprogress
axios.interceptors.request.use(config => {
  return config
})

// Axios interceptor
axios.interceptors.response.use(
  successResponseHandler,
  errorResponseHandler
)

// Token setter for axios requests
if (store.getters['auth/token']) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters['auth/token']
}


Array.prototype.selectOptions = function (key, val) {
  let newArray = [];
  this.forEach(element => {
    newArray.push({
      value: element[key],
      text: element[val]
    })
  });
  return newArray
}

String.prototype.toKebab = function () {
  return this.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .replace(/(?!^)([A-Z])/g, ' $1')
    .replace(/[_\s]+(?=[a-zA-Z])/g, '-').toLowerCase();
}

/**
 * Traduit puis "capitalise" une chaine.
 * @returns {string} la chaine traduite et "capitalisée"
 * */
String.prototype.translateAndCapitalize = function () {
  let translated = i18n.t(this) !== this ? i18n.t(this) : this;
  return translated.toString().charAt(0).toUpperCase() + translated.toString().slice(1);
}

// Global vars
Vue.prototype.$http = axios
Vue.prototype.$toastr = toastr
Vue.config.productionTip = false

// Capitalize global filter.
Vue.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1)
})

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: {
    App
  },
  mixins: [
    exportPdfMixin,
    formatDatasMixin
  ],
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js